/**
 * A simple object that redirects to resources
 *
 * The format for naming links:
 *  - For top level links reference the "tab"
 *    - example: 'projects'
 *  - For sub links reference the "component"
 *    - example: 'projectsView'
 *  - For browser navigation reference the "direction"
 *    - example: 'back'
 */
const redirectTo = {
  back: () => window.history.go(-1),
  projects: () => window.location.replace(`https://${window.location.hostname}/projects`),
};

export default redirectTo;
